/** Maps a failed RSVP request to an i18n key. Network errors and 429 fall through to the generic message. */
export const rsvpErrorKey = (error: any): string => {
	const status = error?.status ?? error?.response?.status;
	if (status === 404) return 'rsvp.notFound';
	if (status === 400) return 'rsvp.invalid';
	return 'rsvp.error';
};
